export enum DateRangeTypeEnum {
  q1 = 1,
  q2,
  q3,
  q4,
  itd,
  ytd,
  custom,
}
